var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
      auto:
        _vm.path == '/cn/download/miniRTK' ||
        _vm.path == '/cn/download/DasInsightAPP',
      nohf: !_vm.withHF
    },attrs:{"id":"app"}},[(_vm.withHF)?_c('appHeader',{directives:[{name:"show",rawName:"v-show",value:(_vm.hf),expression:"hf"}],class:{ topheader: _vm.path == '/' }}):_vm._e(),_vm._v(" "),_c('router-view',{class:{
        top:
          _vm.path == '/' ||
          _vm.path == '/cn/download/miniRTK' ||
          _vm.path == '/cn/download/DasInsightAPP'
      }}),_vm._v(" "),(_vm.withHF)?_c('appFooter',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d99e7f9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 